export const translateKeysCMS = {
  quality: 'quality',
  back: 'cms_back',
  shareMovie: 'cms_share_movie',
  format: 'format',
  program: 'program',
  hoursAbbr: 'hours_abbr',
  onAir: 'onAir',
  onAir2: 'on_air',
  channels: 'channels',
  june: 'june',
  noProgram: 'noProgram',
  removeFromFavorites: 'removeFromFavorites',
  catchupRecorded: 'catch_up_recorded',
  auto: 'auto_quality',
  off: 'off',
  march: 'march',
  inSubscription: 'inSubscription',
  closeButton: 'close_button_title',
  fullProgram: 'full_programme',
  january: 'january',
  fullScreen: 'fullScreen',
  dislike: 'dislike',
  left: 'left',
  favoriteChannels: 'favoriteChannels',
  videoPlaybackTroubleCauseVodReason: 'video_playback_trouble_cause_vod_reason',
  copyTextButton: 'copy_text_button_title',
  advTitle: 'advertisement_title',
  advMChMidrollTitle: 'advertisement_title_m_ch_midroll',
  advMChPostrollTitle: 'advertisement_title_m_ch_postroll',
  min: 'min',
  minsAbbr: 'mins_abbr',
  shareButtonName: 'shareButtonName',
  december: 'december',
  audiotrack: 'audiotrack',
  previousChannel: 'previousChannel',
  recordedForEpgDatetime: 'recorded_for_epg_datetime',
  october: 'october',
  furtherInProgram: 'furtherInProgram',
  second: 'second',
  through: 'through',
  watchNow: 'watch_now',
  on: 'on',
  yesterday: 'yesterday',
  july: 'july',
  addToFavorites: 'addToFavorites',
  hide: 'hide',
  april: 'april',
  broadcastRecordFrom: 'broadcastRecordFrom',
  trailer: 'trailer',
  shareInSocialNetwork: 'share_in_social_network',
  february: 'february',
  september: 'september',
  movieReviewQuestion: 'movie_review_question',
  earlierInProgram: 'earlierInProgram',
  august: 'august',
  shareButton: 'share_button_title',
  shareFromSocialText: 'shareFromSocialText',
  shareFromSocialTextByTime: 'shareFromSocialTextByTime',
  htmlPlayerCode: 'html_player_code',
  minimize: 'minimize',
  recordingFrom: 'recording.from',
  videoLink: 'video_link',
  tomorrow: 'tomorrow',
  subtitles: 'subtitles',
  linkFromVideoText: 'linkFromVideoText',
  goes: 'goes',
  skipAds: 'skip_ads',
  skipIntro: 'player_skip_intro_button',
  advAdditionalPart: 'advertisement_additional_part',
  goToTheAdvWebsite: 'go_to_the_advertiser_website',
  november: 'november',
  audioTrack: 'audio_track',
  copied: 'copied',
  subtitlesOff: 'subtitles_off',
  download: 'download',
  may: 'may',
  like: 'like',
  settings: 'settings',
  subtitlesOn: 'subtitles_on',
  today: 'today',
  prevChannel: 'previousChannel',
  nextChannel: 'nextChannel',
  sharePhrase: 'sharePhrase',
  watchFromTheStart: 'watchFromTheStart',
  allChannels: 'allChannels',
  bitrateBySubscription: '{bitrate} by_subscription',
  adWillStartAfter: 'ad_will_start_after',
  remindAboutBroadcast: 'remind_about_broadcast',
  dontRemind: 'dont_remind',
  watchOnMgg: 'watch_on_mgg',
  interactive: 'interactive',
  interactiveToggleAll: 'interactiveToggleAll',
  interactiveAllOff_full: 'interactiveAllOff_full',
  interactiveAllOn_full: 'interactiveAllOn_full',
  interactiveAllOff_short: 'interactiveAllOff_short',
  interactiveAllOn_short: 'interactiveAllOn_short',
  withSubtitles: 'with_subtitles',
  pipTooltip: 'pip_tooltip',

  playerReactionsButton: 'player_reactions_button',
  playerBackOnAirButton: 'player_backonair_button',
  playerFromBeginningButton: 'player_frombeginning_button',
  playerRichEpgBadge: 'player_richepg_badge',
  playerPauseButton: 'player_pause_button',
  playerPlayButton: 'player_play_button',
  playerVolumeButton: 'player_volume_button',
  playerVolumeOffButton: 'player_volumeoff_button',
  playerVolumeOnButton: 'player_volumeon_button',
  playerNextEpisodeButton: 'player_nextepisode_button',
  playerEpgButton: 'player_epg_button',
  epgMiniPlayerYouAreWatching: 'you_are_watching.mini_player_epg',
  pipPlayerPlaceholder: 'pip_player_placeholder',
  broadcasting: 'broadcast_status.player',
  onAir3: 'live_status.player',
};

export type TranslateKeysCMSType = typeof translateKeysCMS;
export type TranslateKeysCMSKeysType = keyof TranslateKeysCMSType;
